import * as React from 'react';
import { Progress as ChakraProgress, type ProgressRootProps } from '@chakra-ui/react';

/**
 * Project Progress.
 *
 * NB-shaped facade over Chakra v3's compositional `Progress`. Consumers
 * keep using `<Progress value={n} />`. Replicates the old NB Progress
 * theme: full-bleed mint (#CEF2F1) track with a secondary.50 fill and
 * square corners.
 */

export type ProgressProps = Omit<ProgressRootProps, 'value'> & {
  value?: number;
};

export const Progress = React.forwardRef<HTMLDivElement, ProgressProps>(
  ({ value = 0, ...rest }, ref) => (
    <ChakraProgress.Root ref={ref} value={value} width="100%" {...rest}>
      <ChakraProgress.Track bg="#CEF2F1" rounded="0">
        <ChakraProgress.Range bg="secondary.50" rounded="0" />
      </ChakraProgress.Track>
    </ChakraProgress.Root>
  )
);
Progress.displayName = 'Progress';
